import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProgressBarService {

  private _isLoading: BehaviorSubject<boolean> = new BehaviorSubject(false);

  public isLoading$ = this._isLoading.asObservable();


  start() {
    this._isLoading.next(true);
  }

  end() {
    this._isLoading.next(false);
  }

}
